export default class User{
  // firebaseのUserデータを前提
  constructor(data) {
    this._uid            = data.uid;
    this._email          = data.email;
    this._receipts       = [];
    this._isPaidFlg      = false;  // 課金済み
    this._subscribed     = false; // 一度でも契約したことがある。
    this._facebook_token = data.facebook_token;
    this._created_date   = data.created_date;
    this._updated_date   = data.updated_date;
  }

  get uid()   { return this._uid }
  get email() { return this._email }
  get isPaidFlg() { return this._isPaidFlg }
  get isSubscribed() { return this._subscribed }
  get createdDate() { return this._created_date }
  get updatedDate() { return this._updated_date }

  // web登録かどうかのチェック
  checkWebRegistration(callback) {
    requestServer(`/api/v1/user/web_registration?uid=${this._uid}`, 'GET', null, (response) => {
      obs.response = response
      callback(response)
    })
  }

  // 登録経路のアイコンを返す
  registrationIcon() {
    if(this._facebook_token === null) {
      return "envelope"
    } else {
      return "facebook"
    }
  }

  // 課金状況のチェック
  checkReceiptData(callback) {
    // nodeサーバーに通信
    requestNodeServer("/api/v1/user/check_payment", 'POST', {uid: this._uid}).then((response) => {
      console.warn(response)
      if(response.error) {
        window.error("通信に失敗しました。運営にお問い合わせください")
        return false
      }
      this._subscribed = response.subscribed
      this._isPaidFlg  = response.paid
      callback()
    })
  }

  // Emailが更新された時にfirestoreのデータも更新する
  updateEmail(callback) {
    requestNodeServer("/api/v1/user/email", 'POST', {uid: this._uid, email: this._email }).then((response) => {
      console.warn(response)
      callback(response.result)
    })
  }

  getStripeData(callback) {
    if(!obs.firebase) {
      console.warn("Firebase SDKを読み込んでください")
      return false
    }
    var db = obs.firebase.firestore()
    db.collection("purchase-stripe").doc(this._uid).get().then((doc) => {
      if (!doc.exists) {
        return window.error("購入情報が確認できませんでした", doc)
      }
      callback(doc.data())
    })
  }
}
